import { Locale } from "../schema/Locale.js";
import { makeInflect } from "./makeInflect.js";

export const inflectHours = {
	[Locale.cs]: makeInflect("hodina", "hodiny", "hodin"),
	[Locale.en]: makeInflect("hour", "hours", "hours"),
};
export const inflectMinutes = {
	[Locale.cs]: makeInflect("minuta", "minuty", "minut"),
	[Locale.en]: makeInflect("minute", "minutes", "minutes"),
};
export const inflectDays = {
	[Locale.cs]: makeInflect("den", "dny", "dnů"),
	[Locale.en]: makeInflect("day", "days", "days"),
};
